import useJobConfig from '../hooks/useJobConfig';

// Tailwind class lookup for {bg,text,border} per color key.
const COLOR_STYLES = {
  slate: 'bg-slate-100 text-slate-700 border-slate-200',
  red: 'bg-red-100 text-red-700 border-red-200',
  orange: 'bg-orange-100 text-orange-700 border-orange-200',
  amber: 'bg-amber-100 text-amber-700 border-amber-200',
  yellow: 'bg-yellow-100 text-yellow-700 border-yellow-200',
  lime: 'bg-lime-100 text-lime-700 border-lime-200',
  green: 'bg-green-100 text-green-700 border-green-200',
  emerald: 'bg-emerald-100 text-emerald-700 border-emerald-200',
  teal: 'bg-teal-100 text-teal-700 border-teal-200',
  cyan: 'bg-cyan-100 text-cyan-700 border-cyan-200',
  sky: 'bg-sky-100 text-sky-700 border-sky-200',
  blue: 'bg-blue-100 text-blue-700 border-blue-200',
  indigo: 'bg-indigo-100 text-indigo-700 border-indigo-200',
  violet: 'bg-violet-100 text-violet-700 border-violet-200',
  purple: 'bg-purple-100 text-purple-700 border-purple-200',
  pink: 'bg-pink-100 text-pink-700 border-pink-200',
  rose: 'bg-rose-100 text-rose-700 border-rose-200',
};

export default function JobStatusBadge({ status }) {
  const { labelForStatus, colorForStatus, statuses, loading } = useJobConfig();
  // Detect orphans (status that doesn't exist in config any more)
  const isOrphan = !loading && (statuses || []).every((s) => s.value !== status);
  const color = isOrphan ? 'slate' : colorForStatus(status);
  const classes = COLOR_STYLES[color] || COLOR_STYLES.slate;
  return (
    <span
      className={`inline-flex items-center px-3 py-1 rounded-md text-xs font-semibold border ${classes}`}
      title={isOrphan ? 'This status was removed from your config' : undefined}
    >
      {labelForStatus(status)}
      {isOrphan && <span className="ml-1 text-amber-600">⚠</span>}
    </span>
  );
}
